// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookitupNotification } from '../../../../Types/LogT';

const QuestionnaireCreated: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { entityLabel, entityId, eventId } = notification;
  const navigate = useNavigate();

  return (
    <Text>
      <Text
        span
        weight="bolder"
        variant="link"
        color="blue"
        onClick={() => navigate(`/events/${eventId}/questionnaires/${entityId}`)}
        sx={{ cursor: 'pointer' }}
      >
        Fragebogen
      </Text>{' '}
      wurde aus Vorlage
      {entityLabel && (
        <Text
          span
          weight="bolder"
          variant="link"
          color="blue"
          onClick={() => navigate(`/settings/template/questionnaire/${entityLabel}`)}
          sx={{ cursor: 'pointer' }}
        >
          {` ${entityLabel} `}
        </Text>
      )}
      erstellt.
    </Text>
  );
};

export default QuestionnaireCreated;
